import React, { useEffect, useState } from 'react'
import logoSC from "../../Imagenes/logoSCTKD.webp"

import { Typography, Button, Paper } from '@material-ui/core';
import { useNavigate } from "react-router"
import { makeStyles } from '@material-ui/styles';

import { useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import moment from 'moment/moment';

const Styles = makeStyles({

    card: {
        width: "100%",
        maxWidth: 360,
        margin: "0 auto",
        backgroundColor: "rgba(20, 24, 33, 0.65)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: 16,
        padding: 16,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    cardTitle: {
        width: "100%",
        color: "#ffffff",
        fontWeight: 800,
        fontStyle: "italic",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: 18,
        textAlign: "center",
        textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        paddingBottom: 10,
        marginBottom: 12
    },
    row: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "12px 0",
        borderBottom: "1px solid rgba(255, 255, 255, 0.06)"
    },
    rowOro: {
        background: "rgba(212, 175, 55, 0.18)",
        borderRadius: 8,
        paddingLeft: 8,
        paddingRight: 8
    },
    rowPlata: {
        background: "rgba(192, 192, 192, 0.14)",
        borderRadius: 8,
        paddingLeft: 8,
        paddingRight: 8
    },
    rowBronce: {
        background: "rgba(205, 127, 50, 0.14)",
        borderRadius: 8,
        paddingLeft: 8,
        paddingRight: 8
    },
    rowDestacado: {
        boxShadow: "0 0 0 1px rgba(57, 255, 20, 0.5)",
        backgroundColor: "rgba(57, 255, 20, 0.08)"
    },
    puesto: {
        width: 44,
        height: 44,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        fontWeight: 700,
        fontSize: 16
    },
    puestoOro: {
        backgroundColor: "rgba(212, 175, 55, 0.18)",
        border: "1px solid rgba(212, 175, 55, 0.7)",
        color: "#ffd700",
        textShadow: "0 0 8px rgba(255, 215, 0, 0.6)"
    },
    puestoPlata: {
        backgroundColor: "rgba(192, 192, 192, 0.18)",
        border: "1px solid rgba(192, 192, 192, 0.7)",
        color: "#e0e0e0",
        textShadow: "0 0 8px rgba(192, 192, 192, 0.6)"
    },
    puestoBronce: {
        backgroundColor: "rgba(205, 127, 50, 0.18)",
        border: "1px solid rgba(205, 127, 50, 0.7)",
        color: "#cd7f32",
        textShadow: "0 0 8px rgba(205, 127, 50, 0.6)"
    },
    nombre: {
        color: "#ffffff",
        fontSize: 15,
        fontWeight: 600,
        textTransform: "capitalize",
        paddingLeft: 12,
        boxSizing: "border-box",
        flex: 1
    },
    backBtn: {
        display: "block",
        width: "100%",
        maxWidth: 360,
        margin: "0 auto 16px auto",
        padding: "14px 24px",
        borderRadius: 12,
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: 15,
        color: "#ffffff",
        letterSpacing: 1,
        background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
        border: "1px solid rgba(255, 0, 0, 0.3)",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
        cursor: "pointer",
        transition: "transform 0.2s ease, filter 0.2s ease",
        outline: "none",
        "&:active": {
            transform: "scale(0.98)",
            filter: "brightness(1.2)"
        }
    }
})

const Salto = ({ llave, compId }) => {

    const classes = Styles()
    const { state } = useLocation();
    const navigate = useNavigate()
    const [Encuentros, setEncuentros] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [anio, setAnio] = useState("2020");
    const [cantDias, setCantDias] = useState(1);
    const [loading, setLoading] = useState(true)

    useEffect(() => {

    }, [])


    const salto = (l) => {
        let grupo = []
        const medallas = {
            1: { row: classes.rowOro, puesto: classes.puestoOro },
            2: { row: classes.rowPlata, puesto: classes.puestoPlata },
            3: { row: classes.rowBronce, puesto: classes.puestoBronce }
        }
        for (let index = 1; index <= 3; index++) {
            let puesto = l.filter((x) => x.resultado == index)
            puesto.map((p, i) => {

                const destacado = compId != null && p.competidor_id == compId

                grupo.push(
                    <div key={`${index}-${i}`} className={`${classes.row} ${medallas[index].row} ${destacado ? classes.rowDestacado : ""}`}>

                        <div className={`${classes.puesto} ${medallas[index].puesto}`}>{index}º</div>
                        <Typography className={classes.nombre}>
                            {p.nombre + " " + p.apellido}</Typography>

                    </div>
                )

            })

        }


        return (grupo)
    }

    return (

        <div style={{ height: "auto", width: "100%", color: "white" }}  >

            <Button className={classes.backBtn} onClick={() => navigate(-1)}>
                Volver
            </Button>

            {llave.length > 0 ?

                <div className={classes.card}>
                    <Typography className={classes.cardTitle}>Puestos</Typography>

                    {salto(llave)}
                </div>


                : <>
                    <CircularProgress style={{ color: "#39ff14" }} />
                </>
            }


        </div>
    );
}

export default Salto;
